import { Component } from '@angular/core';

@Component({
  selector: 'app-list-expand',
  templateUrl: './list-expand.component.html',
  styleUrls: ['./list-expand.component.scss']
})
export class ListExpandComponent {

}
